import { render, staticRenderFns } from "./auth-menu-item.vue?vue&type=template&id=519d20ee&scoped=true"
import script from "./auth-menu-item.vue?vue&type=script&lang=js"
export * from "./auth-menu-item.vue?vue&type=script&lang=js"
import style0 from "./auth-menu-item.vue?vue&type=style&index=0&id=519d20ee&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "519d20ee",
  null
  
)

export default component.exports